module.exports = __webpack_public_path__ + "img/logo_headway_test.f9bb8e49.svg";